import { render, staticRenderFns } from "./factor-admin-complete.vue?vue&type=template&id=56b3ae38&"
import script from "./factor-admin-complete.vue?vue&type=script&lang=js&"
export * from "./factor-admin-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports